import { StringValidation } from '../../../../utils/component-validations';
import { action } from '@ember/object';
import { fn } from '@ember/helper';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import FlexColumn from '../../layout/flex/column.gjs';
import Message from './message.gjs';
import Super from '../../core/base.gjs';
import generateUUID from '../../../../utils/generate-uuid';

export const GAP_DEFAULT = '8px';

export default class SpdsFeedbackAlertBannerContainer extends Super {
  arguments = [new StringValidation({ required: ['id'] })];
  baseClass = 'spds-feedback-alert-banner-container';
  classesToMapToAttrs = ['hasContent'];
  componentName = 'Spds::AlertBanner::Container';

  @tracked alerts = [];

  @service alertManager;

  get gap() {
    return this.args.gap ?? GAP_DEFAULT;
  }

  get hasContent() {
    return this.alerts.length > 0;
  }

  constructor() {
    super(...arguments);

    this.alertManager.registerComponent(this);
    this.bindServiceEvents();
  }

  bindServiceEvents() {
    let instance = this.args.id;

    let events = [
      {
        context: this,
        event: 'clearBanner',
        handler: this.removeBanner,
        instance,
      },
      {
        context: this,
        event: 'displayBanner',
        handler: this.displayBanner,
        instance,
      },
    ];

    events.forEach(event => this.alertManager.bindEventHandler(event));
  }

  displayBanner(alert) {
    this.alerts = [...this.alerts, { id: generateUUID(), ...alert }];
  }

  removeBanner(alert) {
    let index = alert ? this.alerts.findIndex(({ id }) => id === alert.id) : 0;
    let removed = this.alerts.splice(index, 1)[0];

    this.alerts = [...this.alerts];

    removed.onClose?.();
  }

  @action
  dismissBanner(alert) {
    this.removeBanner(alert);
  }

  <template>
    <FlexColumn
      @gap={{this.gap}}
      class={{this.classes}}
      data-test-spds-feedback-alert-banner-container={{this.id}}
      id={{this.id}}
      ...attributes
    >
      {{#each this.alerts as |alert|}}
        <Message
          @body={{alert.body}}
          @ctaAlignment={{alert.ctaAlignment}}
          @header={{alert.header}}
          @includeIcon={{alert.includeIcon}}
          @onClose={{fn this.dismissBanner alert}}
          @onPrimaryBtnClick={{alert.onPrimaryBtnClick}}
          @onSecondaryBtnClick={{alert.onSecondaryBtnClick}}
          @primaryBtnText={{alert.primaryBtnText}}
          @secondaryBtnText={{alert.secondaryBtnText}}
          @type={{alert.type}}
        />
      {{/each}}
    </FlexColumn>
  </template>
}
